import template from './carrier.all.html';
import controller from './carrier.all.controller';
import './carrier.all.scss';

let carrierallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template,
  controller
};

export default carrierallComponent;


// WEBPACK FOOTER //
// ./client/app/components/carrier/all/carrier.all.component.js